export const mockProducts = [
  {
    id: '1',
    name: 'Premium WordPress Hosting',
    category: 'Web Hosting',
    image: 'https://public.readdy.ai/ai/img_res/63fd6a01128596e5a1a8d201aea1e86a.jpg',
    commission: '35%',
    clicks: 2847,
    conversions: 142,
    earnings: 4260,
    affiliateLink: 'https://example.com/ref/wordpress-hosting',
    description: 'High-performance WordPress hosting with 99.9% uptime guarantee',
    rating: 4.8,
    reviews: 1243,
    pricing: 'From $3.99/mo',
    tags: ['WordPress', 'Hosting', 'Cloud', 'SSL'],
    features: [
      'Free SSL certificate included',
      '99.9% uptime guarantee with SLA',
      'One-click WordPress installation',
      'Automatic daily backups',
      'Free domain for the first year',
      '24/7 expert support'
    ],
    longDescription: 'Premium WordPress Hosting delivers blazing-fast load times with enterprise-grade infrastructure. Built specifically for WordPress sites, it includes optimized caching, automatic updates, and staging environments. Whether you are running a personal blog or a high-traffic business site, this hosting solution scales effortlessly to meet your needs. Enjoy peace of mind with daily backups, free SSL, and round-the-clock expert support.'
  },
  {
    id: '2',
    name: 'Email Marketing Suite',
    category: 'Marketing Tools',
    image: 'https://readdy.ai/api/search-image?query=professional%20email%20marketing%20automation%20dashboard%20interface%20with%20clean%20modern%20design%20showing%20email%20icons%20and%20analytics%20charts%20on%20soft%20gradient%20background%20from%20light%20purple%20to%20white%20minimalist%20tech%20style&width=400&height=300&seq=prod2&orientation=landscape',
    commission: '40%',
    clicks: 3521,
    conversions: 198,
    earnings: 7920,
    affiliateLink: 'https://example.com/ref/email-marketing',
    description: 'Complete email marketing automation platform for businesses',
    rating: 4.7,
    reviews: 2087,
    pricing: 'From $9.99/mo',
    tags: ['Email', 'Automation', 'Marketing', 'CRM'],
    features: [
      'Drag-and-drop email builder',
      'Advanced automation workflows',
      'A/B testing for campaigns',
      'Detailed analytics and reporting',
      'Segmentation and personalization',
      'Integration with 200+ apps'
    ],
    longDescription: 'Email Marketing Suite is an all-in-one platform designed to help businesses create, automate, and optimize their email campaigns. With an intuitive drag-and-drop builder, you can design stunning emails in minutes. Set up complex automation workflows to nurture leads, recover abandoned carts, and re-engage inactive subscribers. Powerful analytics give you deep insights into open rates, click-through rates, and revenue generated from every campaign.'
  },
  {
    id: '3',
    name: 'SEO Analytics Pro',
    category: 'SEO Tools',
    image: 'https://readdy.ai/api/search-image?query=advanced%20seo%20analytics%20dashboard%20with%20search%20engine%20optimization%20graphs%20and%20keyword%20research%20tools%20clean%20modern%20interface%20on%20soft%20gradient%20background%20from%20light%20purple%20to%20white%20professional%20digital%20marketing%20aesthetic&width=400&height=300&seq=prod3&orientation=landscape',
    commission: '30%',
    clicks: 1923,
    conversions: 87,
    earnings: 2610,
    affiliateLink: 'https://example.com/ref/seo-analytics',
    description: 'Advanced SEO tools for keyword research and competitor analysis',
    rating: 4.6,
    reviews: 956,
    pricing: 'From $29.99/mo',
    tags: ['SEO', 'Analytics', 'Keywords', 'Backlinks'],
    features: [
      'Comprehensive keyword research',
      'Competitor analysis dashboard',
      'Backlink monitoring and audit',
      'Site health and technical SEO checks',
      'Rank tracking across 170+ countries',
      'Content optimization suggestions'
    ],
    longDescription: 'SEO Analytics Pro gives you everything you need to dominate search engine rankings. Discover high-value keywords your competitors are ranking for, monitor your backlink profile, and get actionable recommendations to improve your site health. The rank tracker monitors your positions across 170+ countries so you always know where you stand. Perfect for agencies, freelancers, and in-house marketing teams looking to drive organic traffic growth.'
  },
  {
    id: '4',
    name: 'Social Media Manager',
    category: 'Marketing Tools',
    image: 'https://readdy.ai/api/search-image?query=social%20media%20management%20platform%20dashboard%20with%20multiple%20social%20network%20icons%20and%20scheduling%20calendar%20clean%20modern%20design%20on%20soft%20gradient%20background%20from%20light%20purple%20to%20white%20professional%20marketing%20tool%20aesthetic&width=400&height=300&seq=prod4&orientation=landscape',
    commission: '25%',
    clicks: 2156,
    conversions: 124,
    earnings: 3100,
    affiliateLink: 'https://example.com/ref/social-media',
    description: 'Manage all your social media accounts from one dashboard',
    rating: 4.5,
    reviews: 1678,
    pricing: 'From $12.99/mo',
    tags: ['Social Media', 'Scheduling', 'Analytics', 'Content'],
    features: [
      'Schedule posts across all platforms',
      'Visual content calendar',
      'Social inbox for all messages',
      'Performance analytics per channel',
      'Team collaboration tools',
      'AI-powered caption suggestions'
    ],
    longDescription: 'Social Media Manager simplifies your social media workflow by bringing all your accounts into one powerful dashboard. Schedule and publish content across Instagram, Facebook, Twitter, LinkedIn, and TikTok with a visual calendar. Monitor engagement, respond to messages from a unified inbox, and track performance with detailed analytics. AI-powered suggestions help you craft captions that resonate with your audience.'
  },
  {
    id: '5',
    name: 'Landing Page Builder',
    category: 'Web Design',
    image: 'https://readdy.ai/api/search-image?query=modern%20landing%20page%20builder%20interface%20with%20drag%20and%20drop%20elements%20and%20website%20templates%20clean%20minimalist%20design%20on%20soft%20gradient%20background%20from%20light%20purple%20to%20white%20professional%20web%20design%20tool&width=400&height=300&seq=prod5&orientation=landscape',
    commission: '45%',
    clicks: 4231,
    conversions: 267,
    earnings: 12015,
    affiliateLink: 'https://example.com/ref/landing-builder',
    description: 'Create high-converting landing pages without coding',
    rating: 4.9,
    reviews: 3412,
    pricing: 'From $19.99/mo',
    tags: ['Landing Pages', 'No-Code', 'Conversion', 'Templates'],
    features: [
      '200+ professionally designed templates',
      'Drag-and-drop page builder',
      'Built-in A/B testing',
      'Mobile-responsive designs',
      'Custom domain support',
      'Conversion tracking and analytics'
    ],
    longDescription: 'Landing Page Builder empowers marketers and entrepreneurs to create stunning, high-converting landing pages without writing a single line of code. Choose from over 200 professionally designed templates, customize every element with the intuitive drag-and-drop editor, and launch in minutes. Built-in A/B testing helps you optimize for maximum conversions, while detailed analytics show you exactly how your pages are performing.'
  },
  {
    id: '6',
    name: 'CRM Software',
    category: 'Business Tools',
    image: 'https://readdy.ai/api/search-image?query=customer%20relationship%20management%20crm%20software%20dashboard%20with%20contact%20management%20and%20sales%20pipeline%20visualization%20clean%20modern%20interface%20on%20soft%20gradient%20background%20from%20light%20purple%20to%20white%20professional%20business%20tool&width=400&height=300&seq=prod6&orientation=landscape',
    commission: '35%',
    clicks: 1876,
    conversions: 93,
    earnings: 3255,
    affiliateLink: 'https://example.com/ref/crm-software',
    description: 'Powerful CRM to manage customer relationships and sales',
    rating: 4.7,
    reviews: 2234,
    pricing: 'From $14.99/mo',
    tags: ['CRM', 'Sales', 'Pipeline', 'Contacts'],
    features: [
      'Visual sales pipeline management',
      'Contact and deal tracking',
      'Email integration and tracking',
      'Automated follow-up reminders',
      'Custom reports and dashboards',
      'Mobile app for on-the-go access'
    ],
    longDescription: 'CRM Software helps you close more deals by organizing your entire sales process in one place. Visualize your pipeline, track every interaction with contacts, and never miss a follow-up with automated reminders. Integrate with your email to track opens and clicks, and build custom reports to understand your sales performance. The mobile app keeps you connected to your deals wherever you go.'
  },
  {
    id: '7',
    name: 'Video Editing Software',
    category: 'Creative Tools',
    image: 'https://readdy.ai/api/search-image?query=professional%20video%20editing%20software%20interface%20with%20timeline%20and%20editing%20tools%20modern%20creative%20design%20on%20soft%20gradient%20background%20from%20light%20purple%20to%20white%20high%20end%20production%20tool%20aesthetic&width=400&height=300&seq=prod7&orientation=landscape',
    commission: '30%',
    clicks: 2943,
    conversions: 156,
    earnings: 4680,
    affiliateLink: 'https://example.com/ref/video-editor',
    description: 'Professional video editing suite for content creators',
    rating: 4.8,
    reviews: 1890,
    pricing: 'From $16.99/mo',
    tags: ['Video', 'Editing', 'Content Creation', 'Effects'],
    features: [
      '4K and HDR video support',
      'Advanced color grading tools',
      'Motion graphics and effects library',
      'Multi-track audio editing',
      'Direct publishing to social platforms',
      'Cloud storage for projects'
    ],
    longDescription: 'Video Editing Software is a professional-grade editing suite built for content creators, filmmakers, and marketers. Edit in 4K and HDR with advanced color grading tools that rival industry-standard software. Access a massive library of motion graphics, transitions, and effects. Multi-track audio editing lets you perfect your sound design, and direct publishing to YouTube, Instagram, and TikTok saves you time in your workflow.'
  },
  {
    id: '8',
    name: 'Project Management Tool',
    category: 'Business Tools',
    image: 'https://readdy.ai/api/search-image?query=project%20management%20software%20dashboard%20with%20task%20boards%20and%20team%20collaboration%20features%20clean%20modern%20interface%20on%20soft%20gradient%20background%20from%20light%20purple%20to%20white%20professional%20productivity%20tool&width=400&height=300&seq=prod8&orientation=landscape',
    commission: '40%',
    clicks: 3654,
    conversions: 201,
    earnings: 8040,
    affiliateLink: 'https://example.com/ref/project-mgmt',
    description: 'Streamline team collaboration and project workflows',
    rating: 4.6,
    reviews: 2567,
    pricing: 'From $7.99/mo',
    tags: ['Project Management', 'Collaboration', 'Tasks', 'Agile'],
    features: [
      'Kanban boards and Gantt charts',
      'Time tracking and reporting',
      'File sharing and document management',
      'Sprint planning for agile teams',
      'Custom workflows and automations',
      'Guest access for clients'
    ],
    longDescription: 'Project Management Tool brings your team together with powerful collaboration features designed for modern workflows. Organize work with Kanban boards or Gantt charts, track time spent on tasks, and automate repetitive processes. Agile teams love the sprint planning features, while client-facing teams appreciate guest access for transparent project updates. Integrates with Slack, Google Drive, and 100+ other tools.'
  },
  {
    id: '9',
    name: 'Graphic Design Platform',
    category: 'Creative Tools',
    image: 'https://readdy.ai/api/search-image?query=graphic%20design%20platform%20interface%20with%20design%20templates%20and%20creative%20tools%20modern%20artistic%20layout%20on%20soft%20gradient%20background%20from%20light%20purple%20to%20white%20professional%20creative%20software%20aesthetic&width=400&height=300&seq=prod9&orientation=landscape',
    commission: '35%',
    clicks: 2789,
    conversions: 167,
    earnings: 5845,
    affiliateLink: 'https://example.com/ref/graphic-design',
    description: 'Create stunning graphics with easy-to-use design tools',
    rating: 4.9,
    reviews: 4102,
    pricing: 'From $9.99/mo',
    tags: ['Design', 'Graphics', 'Templates', 'Branding'],
    features: [
      '10,000+ customizable templates',
      'Brand kit with logo and color management',
      'Background remover tool',
      'Resize designs for any platform',
      'Real-time team collaboration',
      'Stock photo and icon library'
    ],
    longDescription: 'Graphic Design Platform makes professional design accessible to everyone. With over 10,000 customizable templates for social media, presentations, flyers, and more, you can create eye-catching visuals in minutes. The brand kit keeps your logos, colors, and fonts organized for consistent branding. Collaborate with your team in real-time, access millions of stock photos and icons, and resize any design for any platform with a single click.'
  }
];

export const mockWebsites = [
  {
    id: '1',
    name: 'TechReview Hub',
    url: 'https://techreviewhub.com',
    category: 'Technology Blog',
    monthlyVisitors: 45000,
    activeLinks: 12,
    totalEarnings: 8450,
    image: 'https://readdy.ai/api/search-image?query=modern%20technology%20blog%20website%20homepage%20with%20tech%20articles%20and%20reviews%20clean%20professional%20design%20on%20soft%20gradient%20background%20from%20light%20purple%20to%20white%20digital%20media%20aesthetic&width=400&height=300&seq=web1&orientation=landscape'
  },
  {
    id: '2',
    name: 'Marketing Mastery',
    url: 'https://marketingmastery.io',
    category: 'Marketing Blog',
    monthlyVisitors: 62000,
    activeLinks: 18,
    totalEarnings: 12340,
    image: 'https://readdy.ai/api/search-image?query=professional%20marketing%20blog%20website%20with%20business%20strategy%20content%20and%20growth%20tips%20clean%20modern%20design%20on%20soft%20gradient%20background%20from%20light%20purple%20to%20white%20business%20media%20aesthetic&width=400&height=300&seq=web2&orientation=landscape'
  },
  {
    id: '3',
    name: 'Startup Success',
    url: 'https://startupsuccess.co',
    category: 'Business Blog',
    monthlyVisitors: 38000,
    activeLinks: 9,
    totalEarnings: 6780,
    image: 'https://readdy.ai/api/search-image?query=startup%20business%20blog%20website%20with%20entrepreneurship%20content%20and%20success%20stories%20clean%20professional%20design%20on%20soft%20gradient%20background%20from%20light%20purple%20to%20white%20business%20publication%20aesthetic&width=400&height=300&seq=web3&orientation=landscape'
  },
  {
    id: '4',
    name: 'Design Inspiration',
    url: 'https://designinspiration.net',
    category: 'Design Blog',
    monthlyVisitors: 51000,
    activeLinks: 15,
    totalEarnings: 9560,
    image: 'https://readdy.ai/api/search-image?query=creative%20design%20blog%20website%20with%20portfolio%20showcases%20and%20design%20tutorials%20modern%20artistic%20layout%20on%20soft%20gradient%20background%20from%20light%20purple%20to%20white%20creative%20media%20aesthetic&width=400&height=300&seq=web4&orientation=landscape'
  },
  {
    id: '5',
    name: 'Developer Tools Review',
    url: 'https://devtoolsreview.com',
    category: 'Developer Blog',
    monthlyVisitors: 72000,
    activeLinks: 21,
    totalEarnings: 15890,
    image: 'https://readdy.ai/api/search-image?query=developer%20tools%20review%20website%20with%20coding%20tutorials%20and%20software%20comparisons%20clean%20technical%20design%20on%20soft%20gradient%20background%20from%20light%20purple%20to%20white%20tech%20publication%20aesthetic&width=400&height=300&seq=web5&orientation=landscape'
  },
  {
    id: '6',
    name: 'E-commerce Insights',
    url: 'https://ecommerceinsights.io',
    category: 'E-commerce Blog',
    monthlyVisitors: 44000,
    activeLinks: 13,
    totalEarnings: 7920,
    image: 'https://readdy.ai/api/search-image?query=ecommerce%20business%20blog%20website%20with%20online%20store%20tips%20and%20sales%20strategies%20clean%20professional%20design%20on%20soft%20gradient%20background%20from%20light%20purple%20to%20white%20business%20media%20aesthetic&width=400&height=300&seq=web6&orientation=landscape'
  }
];

export const mockAffiliateLinks = [
  {
    id: '1',
    productName: 'Premium WordPress Hosting',
    shortUrl: 'https://aff.link/wp-host',
    fullUrl: 'https://example.com/ref/wordpress-hosting?aid=12345',
    clicks: 2847,
    conversions: 142,
    revenue: 4260,
    status: 'active',
    createdAt: '2024-01-15',
    lastClick: '2024-03-10'
  },
  {
    id: '2',
    productName: 'Email Marketing Suite',
    shortUrl: 'https://aff.link/email-mkt',
    fullUrl: 'https://example.com/ref/email-marketing?aid=12345',
    clicks: 3521,
    conversions: 198,
    revenue: 7920,
    status: 'active',
    createdAt: '2024-01-20',
    lastClick: '2024-03-11'
  },
  {
    id: '3',
    productName: 'SEO Analytics Pro',
    shortUrl: 'https://aff.link/seo-pro',
    fullUrl: 'https://example.com/ref/seo-analytics?aid=12345',
    clicks: 1923,
    conversions: 87,
    revenue: 2610,
    status: 'active',
    createdAt: '2024-02-01',
    lastClick: '2024-03-09'
  },
  {
    id: '4',
    productName: 'Social Media Manager',
    shortUrl: 'https://aff.link/social',
    fullUrl: 'https://example.com/ref/social-media?aid=12345',
    clicks: 2156,
    conversions: 124,
    revenue: 3100,
    status: 'active',
    createdAt: '2024-02-05',
    lastClick: '2024-03-10'
  },
  {
    id: '5',
    productName: 'Landing Page Builder',
    shortUrl: 'https://aff.link/landing',
    fullUrl: 'https://example.com/ref/landing-builder?aid=12345',
    clicks: 4231,
    conversions: 267,
    revenue: 12015,
    status: 'active',
    createdAt: '2024-01-10',
    lastClick: '2024-03-11'
  },
  {
    id: '6',
    productName: 'CRM Software',
    shortUrl: 'https://aff.link/crm',
    fullUrl: 'https://example.com/ref/crm-software?aid=12345',
    clicks: 1876,
    conversions: 93,
    revenue: 3255,
    status: 'paused',
    createdAt: '2024-02-15',
    lastClick: '2024-03-08'
  }
];

export const mockDashboardStats = {
  totalClicks: 18554,
  totalConversions: 1011,
  totalRevenue: 43180,
  conversionRate: 5.45,
  activeLinks: 24,
  activeWebsites: 6,
  monthlyGrowth: 23.5,
  topPerformer: 'Landing Page Builder'
};